import { useLazyQuery } from '@apollo/client'
import { MD5 } from 'crypto-js'

import getSignatureKey from '../graphqls/getSignatureKey'

const MAX_RETRIES = 2

const useGetDynamicToken = () => {
  const [querySignatureKey, { loading }] = useLazyQuery(getSignatureKey, {
    fetchPolicy: 'no-cache',
  })

  const getDynamicKey = async (retryCount = 0): Promise<string> => {
    try {
      const { data } = await querySignatureKey()
      const key = data?.getSignatureKey?.key || ''

      // If key is empty and max retries not reached, retry
      if (!key && retryCount < MAX_RETRIES) {
        return getDynamicKey(retryCount + 1)
      }

      return key
    } catch (error) {
      if (retryCount < MAX_RETRIES) {
        return getDynamicKey(retryCount + 1)
      }
      throw error
    }
  }

  const getHeaderWithDynamicToken = async () => {
    const key = await getDynamicKey()
    const timestamp = Date.now()
    const text = `api=saveleads&timestamp=${timestamp}&signature=${key}`
    const signMessage = MD5(text).toString()

    return {
      timestamp,
      signature: signMessage,
      key,
    }
  }

  return { getHeaderWithDynamicToken, signatureKeyLoading: loading }
}

export default useGetDynamicToken
